import { makeStyles } from '@material-ui/core/styles';

export const useStyle = makeStyles((theme) => {
  return {
    row: {
      marginBottom: theme.spacing(2),
    },
  };
});
